import axiosPlugin from './axios.plugin';
import sentryPlugin from './sentry.plugin';

const plugins = [axiosPlugin, sentryPlugin];

export default plugins;
